import OTPValidationFormContainer from './OTPValidationFormContainer';

export default OTPValidationFormContainer;
